import { Routes } from '@angular/router';
import { authGuard, roleGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'auth',
    loadComponent: () =>
      import('./features/auth/auth-layout.component').then((m) => m.AuthLayoutComponent),
    children: [
      {
        path: 'login',
        loadComponent: () =>
          import('./features/auth/login/login.component').then((m) => m.LoginComponent),
      },
      {
        path: 'sign-up',
        loadComponent: () =>
          import('./features/auth/signup/signup.component').then((m) => m.SignupComponent),
      },
      {
        path: 'forgot-password',
        loadComponent: () =>
          import('./features/auth/forgot-password/forgot-password.component').then(
            (m) => m.ForgotPasswordComponent,
          ),
      },
      {
        path: 'verify_email',
        loadComponent: () =>
          import('./features/auth/email-verification/email-verification.component').then(
            (m) => m.EmailVerificationComponent,
          ),
      },
      {
        path: 'reset_password',
        loadComponent: () =>
          import('./features/auth/reset-password/reset-password.component').then(
            (m) => m.ResetPasswordComponent,
          ),
      },
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: 'admin',
    loadComponent: () => import('./features/admin/admin.component').then((m) => m.AdminComponent),
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/admin/dashboard/dashboard.component').then(
            (m) => m.AdminDashboardComponent,
          ),
      },
      // {
      //   path: 'documents',
      //   loadComponent: () =>
      //     import('./features/admin/documents/documents.component').then(
      //       (m) => m.AdminDocumentsComponent,
      //     ),
      // },
      // {
      //   path: 'document-upload',
      //   canActivate: [roleGuard((a) => a.canUpload())],
      //   loadComponent: () =>
      //     import('./features/admin/document-upload/document-upload.component').then(
      //       (m) => m.AdminDocumentUploadComponent,
      //     ),
      // },
      // {
      //   path: 'scan',
      //   canActivate: [roleGuard((a) => a.canScan())],
      //   loadComponent: () =>
      //     import('./features/admin/scan/scan.component').then((m) => m.AdminScanComponent),
      // },
      {
        path: 'notifications',
        loadComponent: () =>
          import('./features/admin/notifications/notifications.component').then(
            (m) => m.NotificationsComponent,
          ),
      },
      {
        path: 'users',
        canActivate: [roleGuard((a) => a.canManageUsers())],
        loadComponent: () =>
          import('./features/admin/users/users.component').then((m) => m.UsersComponent),
      },
      // {
      //   path: 'departments',
      //   canActivate: [roleGuard((a) => a.canManageLibrary())],
      //   loadComponent: () =>
      //     import('./features/admin/departments/departments.component').then(
      //       (m) => m.DepartmentsComponent,
      //     ),
      // },
      {
        path: 'cabinets',
        canActivate: [roleGuard((a) => a.canManageLibrary())],
        loadComponent: () =>
          import('./features/admin/cabinets/cabinets.component').then((m) => m.CabinetsComponent),
      },
      // {
      //   path: 'folders',
      //   canActivate: [roleGuard((a) => a.canManageLibrary())],
      //   loadComponent: () =>
      //     import('./features/admin/folders/folders.component').then((m) => m.FoldersComponent),
      // },
    ],
  },
  {
    path: '',
    loadComponent: () =>
      import('./features/public/public.component').then((m) => m.PublicComponent),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/public/home/home.component').then((m) => m.HomeComponent),
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
